var map = {
	"./ar/translation.json": 1914,
	"./de/translation.json": 1915,
	"./el/translation.json": 1916,
	"./en/translation.json": 1917,
	"./es/translation.json": 1918,
	"./fil/translation.json": 1919,
	"./fr/translation.json": 1920,
	"./hi/translation.json": 1921,
	"./id/translation.json": 1922,
	"./it/translation.json": 1923,
	"./ko/translation.json": 1924,
	"./ms/translation.json": 1925,
	"./nl/translation.json": 1926,
	"./pl/translation.json": 1927,
	"./pt-BR/translation.json": 1928,
	"./pt-PT/translation.json": 1929,
	"./ru/translation.json": 1930,
	"./se/translation.json": 1931,
	"./tr/translation.json": 1932,
	"./uk/translation.json": 1933,
	"./zh/translation.json": 1934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1913;